export default "__VITE_ASSET__oAHqc$bb__"